import React from 'react';
import {Tree, Icon, Input} from 'antd';

import {UUID_NULL} from '../constants/defaultValues'
import {locdau} from '../utils'

const TreeNode = Tree.TreeNode;
const Search = Input.Search;

class GroupTreeMultiSelect extends React.Component {
  constructor(props) {
    super(props);
    const {groups, treeGroups, selectedKeys} = this.props
    this.state = {
      treeGroups: treeGroups,
      groups: groups,
      checkedKeys: selectedKeys,
      expandedKeys: [],
      autoExpandParent: true,
      searchValue: ''
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedKeys.length !== this.props.selectedKeys.length) {
      const {groups, selectedKeys} = nextProps
      const parentKeys = groups.filter((item) => {
        const index = selectedKeys.findIndex((key) => {
          return item.ID === key
        })
        return index > -1
      }).map(item => item.ParentID)
      this.setState({groups: groups, checkedKeys: selectedKeys, expandedKeys: parentKeys})
      return
    }
    this.setState({groups: nextProps.groups, treeGroups: nextProps.treeGroups})
  }

  hanldeExpand = (expandedKeys) => {
    this.setState({expandedKeys, autoExpandParent: false});
  }

  handleCheck = (checkedKeys) => {
    this.props.onSelectedKeys(checkedKeys)
    this.setState({checkedKeys});
  }

  handleSearch = (e) => {
    const value = e.target.value
    const {groups} = this.props
    const parentKeys = groups.filter((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(value).toLowerCase()
      return kodau.indexOf(kodauSearch) > -1
    }).map(item => item.ParentID)
    this.setState({expandedKeys: parentKeys, autoExpandParent: true, searchValue: value})
  }

  render() {
    const {
      treeGroups,
      groups,
      expandedKeys,
      checkedKeys,
      autoExpandParent,
      searchValue
    } = this.state
    const fullTreeGroups = [...treeGroups]
    const loop = treeGroups => treeGroups.map((item) => {
      const disabled = item.ParentID === UUID_NULL
        ? true
        : false
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(searchValue).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const beforeStr = item.Name.substr(0, index);
      const matchStr = item.Name.substr(index, searchValue.length);
      const afterStr = item.Name.substr(index + searchValue.length);
      const title = index > -1
        ? (<span>
          {beforeStr}
          <span className="highlight">{matchStr}</span>
          {afterStr}
        </span>)
        : <span>{item.Name}</span>;

      if (item.Childs.length > 0) {
        return (<TreeNode title={title} dataRef={item} key={item.ID}>
          {loop(item.Childs)}
        </TreeNode>);
      }
      return <TreeNode title={title} dataRef={item} key={item.ID}/>;
    })
    return (<div>
      <Search style={{
          marginBottom: 8,
          width: "100%"
        }} placeholder="Nhập địa bàn" onChange={this.handleSearch}/>
      <Tree checkable={true} showLine={true} onExpand={this.hanldeExpand} onCheck={this.handleCheck} expandedKeys={expandedKeys} autoExpandParent={autoExpandParent} checkedKeys={checkedKeys}>
        {loop(treeGroups)}
      </Tree>
    </div>);
  }
}

export default GroupTreeMultiSelect



// WEBPACK FOOTER //
// ./src/components/GroupTreeMultiSelect.js